// @ts-nocheck
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRoleAssignments } from "@/hooks/useUserRoleAssignments";
const VendorPressDashboardIndex: React.FC = () => {
  const { profile, isLoading } = useAuth();
  const { allowedDashboardPaths, isLoading: roleLoading } = useUserRoleAssignments();

  console.log('🏠 VendorPressDashboardIndex - Profile:', profile);
  console.log('🏠 VendorPressDashboardIndex - Allowed dashboard paths:', allowedDashboardPaths);
  console.log('🏠 VendorPressDashboardIndex - Loading states:', { isLoading, roleLoading });
  console.log('🏠 VendorPressDashboardIndex - Current window location:', window.location.href);

  // Show loading state while checking authentication
  if (isLoading || roleLoading) {
    console.log('⏳ VendorPressDashboardIndex - Showing loading state');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user has access to vendor-press-dashboard
  // Access comes from the authoritative role assignments only.
  const hasAccess = allowedDashboardPaths.includes('/vendor-press-dashboard') ||
                   allowedDashboardPaths.includes('/vendor-dashboard');

  console.log('🔐 VendorPressDashboardIndex - Access check:', {
    hasAccess,
    profileRole: profile?.role
  });

  // Redirect if no access
  if (!profile || !hasAccess) {
    console.log('❌ VendorPressDashboardIndex - Redirecting to login - no access');
    return <Navigate to="/auth/login" replace />;
  }

  console.log('✅ VendorPressDashboardIndex - Rendering dashboard');
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Vendor Dashboard</h1>
      <p className="text-gray-600">Welcome to your vendor dashboard.</p>
    </div>
  );
};

export default VendorPressDashboardIndex;
